import React from 'react';
import PropTypes from 'prop-types';
import FontIcon from 'material-ui/FontIcon';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import { SLIDE_CONFIG } from 'constants/panelConfig';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as workOrderActions from 'actions/workOrderActions';
import * as siteActions from 'actions/siteActions';
import Divider from 'material-ui/Divider';
import { chatUrl } from '../constants/apiUrls';

export class Footer extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.clearOrderDetail = this
            .clearOrderDetail
            .bind(this);

        this.gotoMyRoute = this
            .gotoMyRoute
            .bind(this);

        this.gotoWorkOrder = this
            .gotoWorkOrder
            .bind(this);

        this.handleMenuToggle = this
            .handleMenuToggle
            .bind(this);

        this.delayAction = this
            .delayAction
            .bind(this);

        this.handleMessagePageRedirect = this
            .handleMessagePageRedirect
            .bind(this);

    }

    delayAction(action, ...args) {
        // we need a delay, else the menu will not have time to toggle
        setTimeout(function () {
            if (typeof action === 'string' && args[0] && args[0].forceNewTab) {
                // action is a URL, open in new tab
                window.open(action, '_blank');
            } else {
                action(...args);
            }
        }, 0);
    }

    gotoWorkOrder() {
        const { history, match } = this.props;

        const orderId = match.params.workOrderId;

        this.delayAction(history.push, `/work-order-close/${orderId}`);
    }

    gotoMyRoute() {
        const { history } = this.props;

        this.delayAction(history.push, `/my-route`);
    }

    clearOrderDetail() {

        const { workOrderActions, match, workOrder } = this.props;
        const orderId = match.params.workOrderId;
        const slideIndex = workOrder.getIn(['workOrderDetails', orderId, 'slideIndex']);
        const slideConfig = SLIDE_CONFIG[slideIndex];

        slideConfig
            .detailKey
            .forEach((detailKey) => {
                workOrderActions.clearWorkOrderDetail(orderId, detailKey, detailKey === 'equipmentDetails');
            });

    }

    handleMenuToggle(open) {
        const { siteActions } = this.props;
        siteActions.toggleDrawer(`footerMenu`, open);
    }

    handleMessagePageRedirect() {
        const { match, user, techData } = this.props;

        if (techData && user) {
            const params = {
                techName: user.toJS().name,
                techid: techData.toJS().techs[user.toJS().userId].info.techId,
                techemail: user.toJS().email || "N/A",
                workorder: match.params.workOrderId || "N/A"
            };

            let url = chatUrl;
            for (let key in params) {
                url += (url.endsWith('?') ? '' : '&') + key + "=" + encodeURIComponent(params[key]);
            }

            window.open(url, '_blank', 'noopener,noreferrer');
        } else {
            alert('Failed to load user or tech data');
        }
    }

    render() {

        const { match, workOrder } = this.props;

        const orderId = match.params.workOrderId;
        const slideIndex = workOrder.getIn(['workOrderDetails', orderId, 'slideIndex']);
        const orderStatus = workOrder.getIn(['workOrderDetails', orderId, 'orderStatus', 'details', 'serviceOrderStatus']);
        const slideConfig = SLIDE_CONFIG[slideIndex];

        let refreshMenuItem = null,
            closeOrderLink = null;

        const completeIcon = (
            <FontIcon className="material-icons">cloud_done</FontIcon>
        );

        const refreshIcon = (
            <FontIcon className="material-icons">cached</FontIcon>
        );

        const mailIcon = (
            <FontIcon className="material-icons">mail</FontIcon>
        );

        const carIcon = (
            <FontIcon className="material-icons">directions_car</FontIcon>
        );

        if (slideConfig && slideConfig.detailKey && slideConfig.detailKey.length > 0 && orderId && match.path !== '/work-order-close/:workOrderId') {
            refreshMenuItem = (<MenuItem
                leftIcon={refreshIcon}
                primaryText={`Refresh ${slideConfig.refreshLabel}`}
                onTouchTap={this.clearOrderDetail} />);
        }

        if (orderId && orderStatus && orderStatus.first().get('dispatchStatus') === 'IN_PROGRESS' && match.path !== '/work-order-close/:workOrderId') {
            closeOrderLink = (<MenuItem
                onTouchTap={this.gotoWorkOrder}
                leftIcon={completeIcon}
                primaryText="Complete Order" />);
        }

        const menuButton = (
            <FloatingActionButton onTouchTap={(e) => e.preventDefault()}>
                <MoreVertIcon />
            </FloatingActionButton >
        );

        let divider = null;

        if (refreshMenuItem || closeOrderLink) {
            divider = (<Divider />);
        }

        return (
            <span>
                <IconMenu
                    useLayerForClickAway={true}
                    onRequestChange={this.handleMenuToggle}
                    style={{
                        position: 'fixed',
                        bottom: '5px',
                        left: '5px',
                        zIndex: '500'
                    }}
                    iconButtonElement={menuButton}
                    anchorOrigin={{
                        horizontal: 'left',
                        vertical: 'top'
                    }}
                    targetOrigin={{
                        horizontal: 'left',
                        vertical: 'top'
                    }}>
                    {refreshMenuItem}
                    {closeOrderLink}
                    {divider}
                    <MenuItem
                        onTouchTap={this.handleMessagePageRedirect}
                        leftIcon={mailIcon}
                        primaryText="Messages" />

                    <MenuItem onTouchTap={this.gotoMyRoute} leftIcon={carIcon} primaryText="Route" />

                </IconMenu>

            </span>
        );
    }
}

Footer.propTypes = {
    history: PropTypes
        .shape({ push: PropTypes.func.isRequired })
        .isRequired,
    siteActions: PropTypes.object,
    workOrderActions: PropTypes.object,
    workOrder: PropTypes.object,
    match: PropTypes.object,
    user: PropTypes.object,
    techData: PropTypes.object
};
function mapStateToProps(state) {
    return {
        workOrder: state.get('workOrder'),
        site: state.get('site'),
        techData: state.get('techData'),
        user: state.get('user'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        workOrderActions: bindActionCreators(workOrderActions, dispatch),
        siteActions: bindActionCreators(siteActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Footer));



// WEBPACK FOOTER //
// ./src/containers/Footer.js